// components/ProtectedToolWrapper.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';

const ProtectedToolWrapper = ({ children, showShareBanner = false }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const isAuthenticated = !!localStorage.getItem('authToken');

  if (!isAuthenticated) {
    const segments = location.pathname.split('/').filter(Boolean);
    const supportedLangs = ["en", "es", "zh-CN", "de", "fr", "ja"];
    const currentLang = supportedLangs.includes(segments[0]) ? segments[0] : 'en';
    const redirectTarget = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/${currentLang}/auth/login?redirect=${redirectTarget}`} replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 p-0">
      <Header />
      <main className="p-4">
        {showShareBanner && (
          <div className="max-w-5xl mx-auto mb-4">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <div className="flex items-center gap-2">
                <div className="text-blue-500">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                  </svg>
                </div>
                <span className="text-sm text-blue-700">
                  {t('shared_tool_configuration_banner')}
                </span>
              </div>
            </div>
          </div>
        )}
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default ProtectedToolWrapper;